__turbopack_context__.v({
  "label": "AJDxgq_label",
  "overflowLabel": "AJDxgq_overflowLabel",
  "root": "AJDxgq_root",
  "section": "AJDxgq_section",
});
